/**
 * @generated SignedSource<<86bfc83d79fdeecb2f55c036aa2f8fc5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type StoreStockDayOfWeek = "Friday" | "Monday" | "Saturday" | "Sunday" | "Thursday" | "Tuesday" | "Wednesday";
export type StoreStockStatus = "IN_STOCK" | "OUT_OF_STOCK";
export type StoreListForOneOfferIdFieldQuery$variables = {
  offerIds?: ReadonlyArray<string> | null;
  limit: number;
  elid?: string | null;
};
export type StoreListForOneOfferIdFieldQuery$data = {
  readonly storeStock: {
    readonly availability: number;
    readonly stores: ReadonlyArray<{
      readonly id: string;
      readonly displayName: string;
      readonly addressLine1: string | null;
      readonly addressLine2: string | null;
      readonly emailAddress: string | null;
      readonly phoneNumber: string | null;
      readonly suburb: string | null;
      readonly city: string | null;
      readonly directions: string | null;
      readonly latitude: number;
      readonly longitude: number;
      readonly image: string | null;
      readonly stockStatus: StoreStockStatus;
      readonly operatingHours: ReadonlyArray<{
        readonly day: StoreStockDayOfWeek | null;
        readonly open: string | null;
        readonly close: string | null;
      }> | null;
    }>;
  };
};
export type StoreListForOneOfferIdFieldQuery = {
  variables: StoreListForOneOfferIdFieldQuery$variables;
  response: StoreListForOneOfferIdFieldQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "elid"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offerIds"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "elid",
        "variableName": "elid"
      },
      {
        "kind": "Variable",
        "name": "limit",
        "variableName": "limit"
      },
      {
        "kind": "Variable",
        "name": "offerIds",
        "variableName": "offerIds"
      }
    ],
    "concreteType": "StoreStockResponse",
    "kind": "LinkedField",
    "name": "storeStock",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "availability",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreStock",
        "kind": "LinkedField",
        "name": "stores",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "addressLine1",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "addressLine2",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phoneNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "suburb",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "city",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "directions",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "latitude",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "longitude",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "image",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stockStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreStockOperatingHours",
            "kind": "LinkedField",
            "name": "operatingHours",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "day",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "open",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "close",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StoreListForOneOfferIdFieldQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StoreListForOneOfferIdFieldQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "a535a0ef9b61c16e0ac804c6a69bf0e1",
    "id": null,
    "metadata": {},
    "name": "StoreListForOneOfferIdFieldQuery",
    "operationKind": "query",
    "text": "query StoreListForOneOfferIdFieldQuery(\n  $offerIds: [String!]\n  $limit: Int!\n  $elid: String\n) {\n  storeStock(offerIds: $offerIds, limit: $limit, elid: $elid) {\n    availability\n    stores {\n      id\n      displayName\n      addressLine1\n      addressLine2\n      emailAddress\n      phoneNumber\n      suburb\n      city\n      directions\n      latitude\n      longitude\n      image\n      stockStatus\n      operatingHours {\n        day\n        open\n        close\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "576312c67f339a9a1c8bebd8da404f5a";

export default node;
